var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfiguration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.563 11.523V10.47l1.32-1.154a1.375 1.375 0 0 0 .261-1.753l-1.622-2.75a1.375 1.375 0 0 0-1.19-.688 1.375 1.375 0 0 0-.44.069l-1.67.564a7.802 7.802 0 0 0-.901-.516l-.35-1.733a1.375 1.375 0 0 0-1.376-1.106H9.378a1.375 1.375 0 0 0-1.375 1.106l-.35 1.733a7.893 7.893 0 0 0-.908.516l-1.637-.592a1.375 1.375 0 0 0-.44-.04 1.375 1.375 0 0 0-1.189.687l-1.622 2.75a1.375 1.375 0 0 0 .281 1.725l1.3 1.19v1.052l-1.3 1.155a1.375 1.375 0 0 0-.281 1.753l1.622 2.75a1.374 1.374 0 0 0 1.19.687c.149.001.298-.022.44-.069l1.67-.563c.289.191.59.364.9.515l.351 1.733a1.375 1.375 0 0 0 1.375 1.107h3.245a1.375 1.375 0 0 0 1.375-1.107l.351-1.733a7.89 7.89 0 0 0 .908-.515l1.663.563a1.375 1.375 0 0 0 1.63-.619l1.567-2.75a1.375 1.375 0 0 0-.282-1.725l-1.3-1.19zm-1.23 4.977-2.359-.797a6.09 6.09 0 0 1-1.863 1.079l-.488 2.468H9.378l-.488-2.44a6.436 6.436 0 0 1-1.857-1.08l-2.365.77-1.622-2.75 1.87-1.65a6.119 6.119 0 0 1 0-2.152L3.046 8.25 4.668 5.5l2.359.798a6.091 6.091 0 0 1 1.863-1.08l.488-2.468h3.245l.488 2.44a6.435 6.435 0 0 1 1.856 1.08l2.365-.77 1.623 2.75-1.87 1.65c.127.712.127 1.44 0 2.152l1.87 1.698-1.623 2.75z",
    fill: "#707070"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 15.125A4.125 4.125 0 1 1 15.125 11 4.084 4.084 0 0 1 11 15.125zm0-6.875A2.688 2.688 0 0 0 8.25 11 2.688 2.688 0 0 0 11 13.75 2.687 2.687 0 0 0 13.75 11 2.688 2.688 0 0 0 11 8.25z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfiguration);
export default __webpack_public_path__ + "static/media/configuration.88094d8f1614a70acb7778526bea0bbd.svg";
export { ForwardRef as ReactComponent };